<div id="error-404" fxLayout="column" fxLayoutAlign="start center">

    <div class="content" fxLayout="column" fxLayoutAlign="center center">
        <div class="error-image">
            500
        </div>

        <img src="./assets/images/errors/500.svg" />

        <div class="error-title pt-16">
            {{errorTitle|translate}}
        </div>

        <div class="message">{{errorMessage| translate}}</div>

    </div>

</div>

